import React from 'react';
import { getStartedBoxStyle as styles } from './getStarted.tailwind';
import footballImg from '../../../assets/svgs/get_started_football.svg';

const GetStartedBox = ({ data }) => {
  return (
    <div className={styles.outer_box}>
      {/* Top right component */}
      <div className={styles.top_right_outer_circle}>
        {/* Inner filled circle */}
        <div className={styles.top_right_inner_circle}>
          {/* Image/Logo */}
          <img src={footballImg} alt={"step" + data?.id || ""} className={styles.top_right_img} />
          {/* step-1, step-2, step-3 */}
          <span className={styles.step_text}>Step {data?.id}</span>
        </div>
      </div>

      {/* Main content */}
      <div className='flex flex-col gap-3 sm:gap-5'>
        {/* card logo image */}
        <img src={data?.image} alt="" className={styles.main_image} />

        <div className='flex flex-col gap-1 sm:gap-2'>
          <h1 className={styles.heading}>{data?.heading}</h1>
          <p className={styles.description}>{data?.description}</p>
        </div>
      </div>
    </div>
  );
}

export default GetStartedBox;
